module.exports = __webpack_public_path__ + "img/danlun.05dabcd4.jpeg";